import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { GET_ADMIN_APPLICATION_FILE_STATUS_URL } from '../../constants/apiUrls';
import { GET_ADMIN_APPLICATION_FILE_STATUS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AdminApplicationFileStatusResponse {
  errMsg: string;
  status: string;
  fileSize: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: AdminApplicationFileStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  applicationType: string;
  fileUuid: string;
  enabled: boolean;
  refetchInterval?:
    | number
    | false
    | ((data: AdminApplicationFileStatusResponse | undefined, query: any) => number | false)
    | undefined;
}

export const useGetAdminApplicationFileStatus = ({
  onSuccess,
  onError,
  applicationType,
  fileUuid,
  enabled,
  refetchInterval,
}: Input) => {
  const getAdminApplicationFileStatus = async () => {
    const res = await axiosClient.get<AdminApplicationFileStatusResponse>(
      GET_ADMIN_APPLICATION_FILE_STATUS_URL(applicationType, fileUuid)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_ADMIN_APPLICATION_FILE_STATUS_QUERY_KEY.concat(fileUuid),
    getAdminApplicationFileStatus,
    {
      onSuccess,
      onError,
      enabled,
      refetchInterval,
    }
  );
};
